import { Button, Card } from "antd";
import VideoModal from "./videoModal";
import { useNavigate } from "react-router-dom";

// import images
import Icon1 from "./../../../assets/images/thank-you/icon1.gif";
import Icon2 from "./../../../assets/images/thank-you/icon2.png";
import Icon3 from "./../../../assets/images/thank-you/icon3.png";
import Icon4 from "./../../../assets/images/thank-you/icon4.png";
import Icon5 from "./../../../assets/images/thank-you/icon5.png";
import Icon6 from "./../../../assets/images/thank-you/icon6.png";
import Icon7 from "./../../../assets/images/thank-you/icon7.png";
import Icon8 from "./../../../assets/images/thank-you/icon8.png";
import Icon9 from "./../../../assets/images/thank-you/icon9.png";
import Icon10 from "./../../../assets/images/thank-you/icon10.png";
import Icon11 from "./../../../assets/images/thank-you/icon11.png";
interface ThankYouprops {
  data?: any;
  userName?: string;
  surveyId?: string | number;
  customerEmail?: string;
  subscriptionStatus?: boolean;
}

const ThankYou: React.FC<ThankYouprops> = ({
  data,
  userName,
  surveyId,
  customerEmail,
  subscriptionStatus,
}) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    // Store surveyId in localStorage
    if (surveyId) {
      localStorage.setItem("surveyId", String(surveyId));
    }

    navigate("/payment-info");
  };

  const isShowUpgradeBtn = !subscriptionStatus;

  return (
    <section className="thankyou">
      <Card className="custom-spacing">
        <h3 className="title">There’s so much more, {userName}</h3>
        <div className="bg thank-you-page">
          <div className="thank-you-content-wrapper">
            <div className="thank-you-content">
              <div className="content">
                <VideoModal />
              </div>
              <h3 className="title thankyou-modal-title">
                Watch This Video Made For You
              </h3>
            </div>
            <img className="icon1" src={Icon1} alt="icon1" />
            <img className="icon2" src={Icon2} alt="icon2" />
            <img className="icon3" src={Icon3} alt="icon3" />
            <img className="icon4" src={Icon4} alt="icon4" />
            <img className="icon5" src={Icon5} alt="icon5" />
            <img className="icon6" src={Icon6} alt="icon6" />
            {/* <img className="icon7" src={Icon7} alt="icon7" /> */}
            <img className="icon8" src={Icon8} alt="icon8" />
            <img className="icon9" src={Icon9} alt="icon9" />
            <img className="icon10" src={Icon10} alt="icon10" />
            <img className="icon11" src={Icon11} alt="icon11" />
          </div>
        </div>
        {isShowUpgradeBtn ? (
          <div className="submit-btn-holder">
            <Button className="submit-btn" onClick={handleUpgrade}>
              Get My Access
            </Button>
          </div>
        ) : (
          <div className="submit-btn-holder">
            <Button className="submit-btn" onClick={() => navigate("/login")}>
              Login
            </Button>
          </div>
        )}
      </Card>
    </section>
  );
};
export default ThankYou;